/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Supplier } from './Supplier';
// @ts-ignore
import {
// @ts-ignore
    SupplierFromJSON,
// @ts-ignore
    SupplierFromJSONTyped,
// @ts-ignore
    SupplierToJSON,
} from './Supplier';

/**
 * 
 * @export
 * @interface SupplierListResponse
 */
export interface SupplierListResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Supplier>}
     * @memberof SupplierListResponse
     */
    items: Array<Supplier>;
}

/**
 * Check if a given object implements the SupplierListResponse interface.
 */
// @ts-ignore
export function instanceOfSupplierListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierListResponseFromJSON(json: any): SupplierListResponse {
    return SupplierListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(SupplierFromJSON)),
    };
}

// @ts-ignore
export function SupplierListResponseToJSON(value?: SupplierListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(SupplierToJSON)),
    };
}

